import React, { Component, PropTypes } from 'react'
import Modal from 'react-bootstrap/lib/Modal';
import Button from 'react-bootstrap/lib/Button';
import ButtonToolbar from 'react-bootstrap/lib/ButtonToolbar';

class EditLienModal extends Component{
    constructor(props){
        super(props);
        this.state = {'href' : this.props.lien.href, 'ltitle' : this.props.lien.ltitle, 'ldesc': this.props.lien.ldesc, 'error': null};
        this._handleSubmit = this._handleSubmit.bind(this);
        this._handleHide = this._handleHide.bind(this);
        this._hrefChanged = (e) => {
                this.setState({'href' : e.target.value});
            };
        this._titleChanged = (e) => {
            this.setState({'ltitle' : e.target.value});
        };

        this._descChanged = (e) => {
            this.setState({'ldesc' : e.target.value});
        };
        this.validateForm = this.validateForm.bind(this);
    }

    componentWillReceiveProps(newProps){
        if (newProps.lien.id !== this.props.lien.id){
            this.setState({'href' : newProps.lien.href, 'ltitle': newProps.lien.ltitle, 'ldesc': newProps.lien.ldesc});
        }
    }

    _handleSubmit(evt){
        evt.preventDefault();
        if (! this.validateForm()){
            return;
        }
        this.props.handleSubmit(this.state);
    }

    _handleHide(evt){
        evt.preventDefault();
        this.props.handleHide();        
    }

    validateForm(){

        let re_weburl = new RegExp(
          "^" +
            // protocol identifier
            "(?:(?:https?|ftp)://)" +
            // user:pass authentication
            "(?:\\S+(?::\\S*)?@)?" +
            "(?:" +
              // IP address exclusion
              // private & local networks
              "(?!(?:10|127)(?:\\.\\d{1,3}){3})" +
              "(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})" +
              "(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})" +
              // IP address dotted notation octets
              // excludes loopback network 0.0.0.0
              // excludes reserved space >= 224.0.0.0
              // excludes network & broacast addresses
              // (first & last IP address of each class)
              "(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])" +
              "(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}" +
              "(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))" +
            "|" +
              // host name
              "(?:(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)" +
              // domain name
              "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*" +
              // TLD identifier
              "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))" +
              // TLD may end with dot
              "\\.?" +
            ")" +
            // port number
            "(?::\\d{2,5})?" +
            // resource path
            "(?:[/?#]\\S*)?" +
          "$", "i"
        );

        if (! this.state.href){
            this.setState({'error' : 'URL manquante'});
            return false;
        }
        if (! this.state.href){
            this.setState({'error' : 'Le titre de l\'URL est manquant'});
            return false;
        }
        if (! re_weburl.test(this.state.href)){
            this.setState({'error' : 'URL invalide'});
            return false;
        }
        this.setState({'error': null});
        return true;

    }

    render(){
        
        let modalTitle = this.props.lien.id ? 'Modifier un lien' : 'Ajouter un lien';
        let buttonClass = '';
        let modalClass = this.props.processing ? "text-muted" : "";
        
        if (! this.state.href || ! this.state.ltitle){
            buttonClass='disabled';
        }
        return (
            <Modal show={this.props.show} onHide={this.props.handleClose} className={modalClass} >
                <Modal.Header closeButton>
                    <Modal.Title>{modalTitle}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form className="form-horizontal">
                    <fieldset>
                        <div className="form-group">
                            <div className="col-sm-12">
                                <label htmlFor="href">Adresse (URL)</label>
                                <input className="form-control" type="url" name="href" ref="href" 
                                            onChange={this._hrefChanged} value={this.state.href || ''} required />                                    
                            </div>
                        </div>
                        <div className="form-group">
                            <div className="col-sm-12">
                                <label htmlFor="ltitle">Titre</label>
                                <input name="ltitle" className="form-control" onChange={this._titleChanged}
                                    value={this.state.ltitle || ''} required />
                                
                            </div>
                        </div>
                        <div className="form-group">
                            <div className="col-sm-12 col-md-10">
                                <label htmlFor="ldesc">Description</label>
                                <textarea name="ldesc" className="form-control" rows="10" id="ldesc" 
                                    defaultValue={this.state.ldesc || ''} onChange={this._descChanged} />
                            </div>
                        </div>
                        {this.state.error && (
                            <div className="alert alert-danger">{this.state.error}</div>
                            )
                        }
                    </fieldset>
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <ButtonToolbar>
                        <Button bsStyle="primary" className={buttonClass} onClick={this._handleSubmit}>Sauver</Button>
                        <Button bsStyle="default" onClick={this._handleHide.bind(this)}>Supprimer</Button>
                        <Button bsStyle="default" onClick={this.props.handleClose}>Fermer</Button>
                    </ButtonToolbar>
                </Modal.Footer>
            </Modal>
        )
    }
}

EditLienModal.propTypes = {
    'handleSubmit' : PropTypes.func.isRequired,
    'handleHide' : PropTypes.func.isRequired,    
    'handleClose' : PropTypes.func.isRequired,
    'lien' : PropTypes.shape({
        'href' : PropTypes.string,
        'ltitle' : PropTypes.string,
        'ldesc' : PropTypes.string
    })
}

export default EditLienModal;


// WEBPACK FOOTER //
// ./auteur/liens/EditLienModal.jsx